module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Tab', {
    attrs: {
      "title": _vm.$trad.brand.navigation.eStore
    }
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("brand.brandHiddenPrice")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 choicesHiddenPrice"
  }, [_c('span', {
    class: {
      active: !_vm.datas.isPriceShown
    },
    on: {
      "click": function($event) {
        _vm.datas.isPriceShown = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("brand.brandHiddenNo")))]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.datas.isPriceShown
    },
    on: {
      "click": function($event) {
        _vm.datas.isPriceShown = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("brand.brandHiddenYes")))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('SelectBloc', {
    attrs: {
      "required": true,
      "options": _vm.currencies,
      "label": _vm.$t('brand.currency')
    },
    model: {
      value: (_vm.datas.currency.id),
      callback: function($$v) {
        _vm.datas.currency.id = $$v
      },
      expression: "datas.currency.id"
    }
  }, [_c('template', {
    slot: "noneValue"
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v(_vm._s(_vm.$t("brand.errorCurrency")))])])], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('CheckboxGroupBloc', {
    attrs: {
      "name": 'shippingMethods',
      "label": _vm.$t('brand.shippingMethods'),
      "options": _vm.shippingMethods
    },
    model: {
      value: (_vm.datas.orderShippingMethods),
      callback: function($$v) {
        _vm.datas.orderShippingMethods = $$v
      },
      expression: "datas.orderShippingMethods"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7c08e8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/tabs/EditBrandEStore.vue
// module id = 3352
// module chunks = 0